import { validateGrade } from '@ublend-npm/gradetype-utils';
import sanitizeGrades from '../../../utils/sanitizeGrades';
import mapGradesWithStudents from '../../../utils/mapGradesWithStudents';

const validateGrades = ({
  uploadedGrades,
  currentGrades,
  emailColumnIndex,
  gradeColumnIndex,
  gradeType,
}) => {
  const gradesWithStudentIds = mapGradesWithStudents({
    uploadedGrades,
    currentGrades,
    emailColumnIndex,
    gradeColumnIndex,
  });
  const { sanitizedGrades, unsetGrades } = sanitizeGrades({
    grades: gradesWithStudentIds,
    gradeType,
  });

  const seen = new Set();
  const duplicated = gradesWithStudentIds.reduce((accum, row) => {
    if (seen.has(row.email)) {
      return [...accum, row.email];
    }
    seen.add(row.email);
    return accum;
  }, []);

  return sanitizedGrades.reduce(
    (accum, row) => {
      const { valid } = validateGrade({ grade: row.grade, gradeType });

      if (valid) {
        accum.valid.push(row);
      } else {
        accum.invalid.push(row);
      }

      return accum;
    },
    { valid: unsetGrades, invalid: [], duplicated: [...new Set(duplicated)] }
  );
};

export default validateGrades;
